import React, { useMemo } from 'react';
import classNames from 'classnames';
import FieldWrapper from 'components/FieldWrapper';
import AddressSearch, {
  AddressSearchProps,
} from 'components/AddressSearch/AddressSearch.component';
import { FieldWrapperProps } from 'components/FieldWrapper/FieldWrapper.component';
import { FieldRenderProps } from 'react-final-form';

import './AddressSearchField.styles.scss';

type AddressSearchFieldProps = FieldWrapperProps &
  AddressSearchProps &
  FieldRenderProps<AddressSearchProps, HTMLElement>;

const AddressSearchField: React.FC<AddressSearchFieldProps> = (props) => {
  const {
    className,
    label,
    required,
    description,
    input: { value, onChange, onBlur },
    meta: { touched, error },
    ...rest
  } = props;

  const hasError = useMemo(() => touched && error, [error, touched]);

  const classes = classNames('address-search-field', className);

  return (
    <FieldWrapper
      className={classes}
      label={label}
      required={required}
      hasError={hasError}
      description={description}
      error={error}
    >
      <AddressSearch
        value={value}
        onChangeValue={onChange}
        onBlur={onBlur}
        {...rest}
      />
    </FieldWrapper>
  );
};

export default AddressSearchField;
